export default __webpack_public_path__ + "static/soehne-halbfett-7c64b3f08310ed6c8036cba3f9fc2041.woff2";